// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tr-top-border-2px[data-v-3ba7453b] {\n  border-top: 2px var(--bulma-table-cell-border-style) var(--bulma-table-cell-border-color) !important;\n}\n", ""]);
// Exports
module.exports = exports;
